import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { HistoryStateBadge } from '@/components/history/HistoryStateBadge'
import { formatDate } from '@/lib/format'
import { describeRecordSummary, describeRound, summarizeHistoryRow } from '@/lib/history'
import type { HistoryCustomerSummary } from '@/api/types'

interface HistoryCustomerRowProps {
  row: HistoryCustomerSummary
}

export function HistoryCustomerRow({ row }: HistoryCustomerRowProps): React.ReactElement {
  const isApplied = row.state === 'applied' && row.last_applied_at !== null
  const stateDetail = isApplied ? formatDate(row.last_applied_at ?? '') : (row.state_note ?? '')
  const hasDetail = stateDetail !== ''
  const isLaterRound = row.round > 1

  return (
    <tr className="border-t border-border/60 align-top">
      <td className="px-3 py-2 tabular-nums">{row.customer_id}</td>
      <td className="px-3 py-2">
        <Link
          to={`/historik/${row.customer_id}`}
          className="font-medium hover:underline"
        >
          {row.name}
        </Link>
        <p className="text-xs text-muted-foreground">{row.person}</p>
      </td>
      <td className="px-3 py-2">{describeRecordSummary(row)}</td>
      <td className="px-3 py-2 text-muted-foreground">{summarizeHistoryRow(row)}</td>
      <td className="px-3 py-2">
        <HistoryStateBadge state={row.state} />
        {hasDetail && <p className="mt-1 max-w-xs text-xs text-muted-foreground">{stateDetail}</p>}
        {isLaterRound && <p className="mt-1 text-xs text-muted-foreground">{describeRound(row.round)}</p>}
      </td>
      <td className="px-3 py-2 text-right">
        <Button
          asChild
          variant="outline"
          size="sm"
          className="rounded-none"
        >
          <Link to={`/historik/${row.customer_id}`}>Öppna</Link>
        </Button>
      </td>
    </tr>
  )
}
